import Dialog from '@/components/Dialog'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: Dialog,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}